import { render, staticRenderFns } from "./weekDashboard.vue?vue&type=template&id=4817d404"
import script from "./weekDashboard.vue?vue&type=script&lang=js"
export * from "./weekDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4817d404')) {
      api.createRecord('4817d404', component.options)
    } else {
      api.reload('4817d404', component.options)
    }
    module.hot.accept("./weekDashboard.vue?vue&type=template&id=4817d404", function () {
      api.rerender('4817d404', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dashboard/week/weekDashboard.vue"
export default component.exports